import React, { useState, useEffect, useRef } from 'react'
import './Profile.css'

import SignerModal from '../../component/profile/SignerModal'
import Spinner from '../../utilities/spinner/Spinner'
import { searchTable, useSortableData, getClassNamesFor } from '../../utilities/tableTools/tableTools'
//Redux
import { getProfiles, getReadyProfile, setTitle } from '../../redux'
import { useSelector, useDispatch } from 'react-redux'

function ViewProfileTable() {
  const [column, setColumn] = useState(1)
  const myRef = useRef()
  const [show, setShow] = useState(false)

  const profile = useSelector((state) => state.profile)

  const dispatch = useDispatch()

  const { items, requestSort, sortConfig } = useSortableData(profile.profiles)

  const handleClose = () => setShow(false)
  const handleShow = (signerId) => {
    setShow(true)
    dispatch(getReadyProfile(signerId))
  }

  useEffect(() => {
    dispatch(setTitle('Profile Table'))
    if (profile.profiles.length === 0) {
      dispatch(getProfiles())
    }
  }, [])

  let profileTableMarkup = !profile.loading ? (
    profile.profiles && !profile.notFound ? (
      <div className='profile-table-container '>
        <div className='profile-filter'>
          <select onChange={(e) => setColumn(e.target.value)}>
            <option value='1'>Name</option>
            <option value='2'>Position</option>
            <option value='3'>Location</option>
            <option value='4'>Email</option>
          </select>
          <input type='text' id='filter' placeholder='Filter..' onKeyUp={(e) => searchTable(e.target.value, myRef, column)} />
        </div>
        <div className='primaryTb profile-table-style'>
          <table ref={myRef}>
            <thead>
              <tr>
                <th className='head-no'>No</th>
                <th className={`head-name ${getClassNamesFor('name', sortConfig)}`} onClick={() => requestSort('name')}>
                  Name
                </th>
                <th
                  className={`head-position ${getClassNamesFor('position', sortConfig)}`}
                  onClick={() => requestSort('position')}
                >
                  Position
                </th>
                <th
                  className={`head-location ${getClassNamesFor('location', sortConfig)}`}
                  onClick={() => requestSort('location')}
                >
                  Location
                </th>
                <th className={`head-email ${getClassNamesFor('email', sortConfig)}`} onClick={() => requestSort('email')}>
                  Email
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((signer, index) => {
                return (
                  <tr key={index}>
                    <td className='row-no'>{index + 1}</td>
                    <td className='clickable-title row-name' onClick={() => handleShow(signer.id)}>
                      {signer.title} {signer.name}
                    </td>
                    <td className='row-position'>{signer.position}</td>
                    <td className='row-location'>{signer.location}</td>
                    <td className='row-email'>{signer.email}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        <SignerModal show={show} handleClose={handleClose} />
      </div>
    ) : (
      <p>The contact is empty.</p>
    )
  ) : (
    <Spinner />
  )

  return profileTableMarkup
}

export default ViewProfileTable
